(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["golfer-partnership-intake"] && !Shopify.designMode) return;
  try {
    
(() => {
  const form = document.getElementById('GolferPartnerForm');
  if (!form) return;
  const steps = [...form.querySelectorAll('[data-step]')];
  const nextButton = form.querySelector('.pg-next');
  const backButton = form.querySelector('.pg-back');
  const submitButton = form.querySelector('.pg-submit');
  const progressBar = form.querySelector('.pg-progress>div span');
  const progressLabel = form.querySelector('.pg-progress strong');
  const progressCount = form.querySelector('.pg-progress p span');
  let activeIndex = 0;
  const showStep = (index) => {
    activeIndex = Math.max(0, Math.min(index, steps.length - 1));
    steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== activeIndex; });
    const current = steps[activeIndex];
    progressBar.style.width = `${activeIndex / (steps.length - 1) * 100}%`;
    progressLabel.textContent = current.dataset.stepLabel;
    progressCount.textContent = `Step ${activeIndex + 1} of ${steps.length}`;
    backButton.hidden = activeIndex === 0;
    nextButton.hidden = activeIndex === steps.length - 1;
    submitButton.hidden = activeIndex !== steps.length - 1;
    current.querySelector('legend')?.focus({ preventScroll: true });
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const validateCurrent = () => {
    const fields = [...steps[activeIndex].querySelectorAll('input,select,textarea')];
    for (const field of fields) {
      if (!field.checkValidity()) { field.reportValidity(); field.focus(); return false; }
    }
    return true;
  };
  nextButton.addEventListener('click', () => { if (validateCurrent()) showStep(activeIndex + 1); });
  backButton.addEventListener('click', () => showStep(activeIndex - 1));
  form.addEventListener('keydown', (event) => { if (event.key === 'Enter' && event.target.tagName !== 'TEXTAREA' && !nextButton.hidden) { event.preventDefault(); nextButton.click(); } });
  const applicationValue = (key) => {
    const field = form.elements.namedItem(`contact[${key}]`);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  };
  const syncApplicationToKlaviyo = () => {
    const properties = {
      '$email': applicationValue('email'),
      '$first_name': applicationValue('First name'),
      '$last_name': applicationValue('Last name'),
      'Home City': applicationValue('Home city'),
      'State': applicationValue('State'),
      'Home Club or Course': applicationValue('Home club or course'),
      'Instagram Profile URL': applicationValue('Instagram profile URL'),
      'Instagram Followers': applicationValue('Instagram followers'),
      'Competitive Level': applicationValue('Competitive level'),
      'Handicap or Status': applicationValue('Handicap or status'),
      'School Team Tour or Circuit': applicationValue('School team tour or circuit'),
      'Competitive Profile URL': applicationValue('Competitive profile URL'),
      'Golf Upside': applicationValue('Golf upside'),
      'Current Brand Relationships': applicationValue('Current brand relationships'),
      'Agency or Representation': applicationValue('Agency or representation'),
      'Current Putter': applicationValue('Current putter'),
      'Handedness': applicationValue('Handedness'),
      'Preferred Putter Length': applicationValue('Preferred putter length'),
      'Preferred Lie Angle': applicationValue('Preferred lie angle'),
      'Paradise Model Preference': applicationValue('Paradise model preference'),
      'Eligibility Confirmation': applicationValue('Eligibility confirmation'),
      'Accuracy Confirmation': applicationValue('Accuracy confirmation'),
      'Program and Privacy Acknowledgement': applicationValue('Program and privacy acknowledgement'),
      'Application Submitted At': new Date().toISOString(),
      'Player Partnership Applicant': true,
      'Player Partnership Source': 'Shopify application',
      'Player Partnership Status': 'New'
    };
    Object.keys(properties).forEach((key) => {
      if (properties[key] === '') delete properties[key];
    });
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', properties]);
    window._learnq.push(['track', 'Player Partnership Application Submitted', properties]);
  };
  form.addEventListener('submit', (event) => {
    if (!validateCurrent()) {
      event.preventDefault();
      return;
    }
    syncApplicationToKlaviyo();
  });
  showStep(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
